<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/system/invoiceTitle/add')">新增抬头</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="公司名称" prop='headerName'>
          <el-input clearable v-model="searchForm.headerName" placeholder="公司名称" />
        </el-form-item>
        <el-form-item label="税号" prop="taxNumber">
          <el-input clearable v-model="searchForm.taxNumber" placeholder="税号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="客户名称" prop="userName"></el-table-column>
        <el-table-column min-width="120" label="抬头类型" prop="headerType">
          <template v-slot="{ row }">
            {{ invoiceHeaderTypeMap.get(row.headerType) || '企业' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="名称" prop="headerName"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="地址" prop="headerAddress"></el-table-column>
        <el-table-column min-width="120" label="电话" prop="headerPhone"></el-table-column>
        <el-table-column min-width="120" label="税号" prop="taxNumber">
          <template v-slot="{ row }">
            {{ row.headerType === '1' ? '/' : row.taxNumber }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="开户行" prop="bankName"></el-table-column>
        <el-table-column min-width="120" label="开户行账号" prop="bankAccount"></el-table-column>
        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <template>
              <el-button type="text" v-if="hasEdit" @click=" $router.push('/system/invoiceTitle/edit?headerId=' + row.headerId)">编辑</el-button>
              <el-button type="text" @click="$router.push('/system/invoiceTitle/detail?headerId=' + row.headerId)">详情</el-button>
              <el-button type="text" v-if="hasDelete" @click="deleteRow(row.headerId)" class="del-btn">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { invoiceHeaderType } from '@/utils/dict'
export default {
  name: 'InvoiceTitle',
  data() {
    return {
      invoiceHeaderTypeMap: invoiceHeaderType,
      tableData: [],
      roles: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        headerName: '',
        taxNumber: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    buttonList() {
      // return this.$store.state.buttonList.map(item => item.butCode)
      return this.$store.getters.getMenuByCode('FPTT')
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    }
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.lyInvoice.selectLyInvoiceHeaderByPage, {
        ...this.searchForm,
        page: this.page,
        size: 10
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    },
    deleteRow(headerId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.lyInvoice.deleteDataLyInvoiceHeader, {
          headerId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// .el-select {
//   width: 100%;
// }</style>
<style lang='scss'>
.account-form {

  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
